import './acoespropostas.scss'

const acoespropostas = ({ acao, nls }) => {
  if (!acao || acao.tipo !== 'padrao') return null

  const acoes = Array.isArray(acao.acoes) ? acao.acoes : []

  if (!acoes.length) return null

  return (
    <div
  className='acoespropostas'
  data-cy='pdca-plan-detail-proposed-actions'
>
      <div className='acoespropostas__title'>
        {nls.proposedActionsTitle.toUpperCase()}
      </div>

      <div className='acoespropostas__content'>
        <div className='acoespropostas__type'>
          <span className='acoespropostas__label'>
            {nls.actionTypeLabel}
          </span>
          <strong className='acoespropostas__value'>
            {nls.actionTypeStandard}
          </strong>
        </div>

        <div
  className='acoespropostas__list'
  data-cy='pdca-plan-detail-proposed-actions-list'
>
          {acoes.map((item, index) => (
            <div
  key={`acao-proposta-${index}`}
  className='acoespropostas__card'
  data-cy='pdca-plan-detail-proposed-action'
>
              <div className='acoespropostas__card-header'>
                {item?.titulo && (
                  <div className='acoespropostas__field acoespropostas__field--grow'>
                    <span className='acoespropostas__label'>
                      {nls.actionTitleLabel}
                    </span>
                    <strong className='acoespropostas__value'>
                      {item.titulo}
                    </strong>
                  </div>
                )}

                {Number(item?.ehrecomendada) === 1 && (
                  <span className='acoespropostas__recommended'>
                    {nls.recommendedLabel}
                  </span>
                )}
              </div>

              {item?.descricao && (
                <div className='acoespropostas__field'>
                  <span className='acoespropostas__label'>
                    {nls.actionDescriptionLabel}
                  </span>
                  <strong className='acoespropostas__value acoespropostas__value--text'>
                    {item.descricao}
                  </strong>
                </div>
              )}

              {item?.setor && (
                <div className='acoespropostas__field'>
                  <span className='acoespropostas__label'>
                    {nls.actionSectorLabel}
                  </span>
                  <strong className='acoespropostas__value'>
                    {item.setor}
                  </strong>
                </div>
              )}

              {item?.justificativa && (
                <div className='acoespropostas__field'>
                  <span className='acoespropostas__label'>
                    {nls.actionJustificationLabel}
                  </span>
                  <strong className='acoespropostas__value acoespropostas__value--text'>
                    {item.justificativa}
                  </strong>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default acoespropostas